<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-1-old-friends">
<h1>Chapter 1 – Old Friends</h1>
<p>The afternoon was hot and humid, the air was filed with the smell of dust particles rising from nearby as tractors ploughed the fields. The rice had been harvested, dried and threshed and cleared from the land. The rainy season had passed, and the monsoon rains had gone. It was November.</p>
<p>“Have you studied for your history exam?” Dao asked Yai, her boyfriend, as they walked to the school auditorium half a kilometre away.</p>
<p>“A bit,” he replied, “but there are still two more days before teacher Bundit will preside over the mid-term exams. I’ve been keen on seeing what kind of show the juniors have planned for us.”</p>
<p>Ying, Dao’s classmate, added, “I heard that teacher Mali and Warun were discussing the contest.”</p>
<p>“What contest?” asked Dao. “I haven’t heard of any such event!”</p>
<p>“Well,” Yai said, “Warun, from the municipality office, had asked some parliament members and together with the tourist organization, arranged for performers, stage, lighting and dances to have a light and sound show for us seniors. This is really the first of its’ kind!”</p>
<p>“Oh yes, and teacher Mali, who teaches up in the hills one day a week, has been asked to bring a few hill-tribe students also to perform in the show,” continued Yai.</p>
<p>“What do they know?” retorted Ying, “they can barely speak the language properly, let alone understand culture!”</p>
<p>“But teacher Mali said that hill-tribe students will be an asset in bringing in lots of tourists to see the show,” said Yai.</p>
<p>“Tourists?! Why do we need them here? Isn’t this local routine of juniors setting up some party for the graduating seniors enough?” Ying was furious.</p>
<p>“Did you realize,” Yai added, “that tourists bring in the much-needed revenue to this area?”</p>
<p>“Yes, of course, but what of our local customs and lifestyle? These will all be on display, and we’ll be laughed at for being old-fashioned or not clever enough,” Ying went on.</p>
<p>“Who knows?” Dao said. “Maybe they’ll like our lifestyles.”</p>
<p>“Hey, we’re here now! Good luck on your exams,” the students called to each other.</p>
<p>After the history exam, Dao and Yai walked the four kilometres home, quietly and thoughtfully.</p>
<p>Rice had been harvested early this year, and now a new crop, pineapple, was being planted on a trial basis on the other side of the fields which rose up against the small hillside. There was never enough water for rice fields. Ying had gone on ahead to the fields to assist in the planting along with his parents and uncle. It felt good to work together.</p>
<p>Tired, Yai sat on a nearby log to eat the sliced guava, dipping it in the chilli and salt-and-sugar mixture. He offered Dao some also before she went home.</p>
<p>“Do you know that teacher Mali asked us to take in one hill-tribe girl to work in the shop after school hours as she’s a dancer in the show?” said Dao, looking keenly at her boyfriend.</p>
<p>“I don’t care! I like YOU, not some hill-tribe girl! I hope she doesn’t stay a long time.” he said as they kept on walking side by side, holding hands.</p>
<p>Dao went home to help her mother Bussaba in the grocery store which was also a small terrace restaurant.</p>
<p>“See you tomorrow!” The friends waved goodbye to each other as they parted at the intersection, each going their own ways.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?30404475